import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import config from "../../../../../../config/config";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { getAllBanner } from "../../../_redux/homepageCrud";
import { actions } from "../../../_redux/homepageRedux";
// import { Slide } from "react-slideshow-image";
// import 'react-slideshow-image/dist/styles.css'

const MaskAndDiscount = (props) => {
  const { state } = useSelector(
    (state) => ({
      state: state.homepage,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  React.useLayoutEffect(() => {
    getAllBanner().then((res) => {
      dispatch(actions.setBanners(res.data.data));
    });
  }, []);

  const jsxreturner = (e) => {
    if (e.title !== "undefined") {
      return (
        <>
          <div className="col-6">
            <h3 style={{ whiteSpace: "nowrap" }}>
              <b>{e ? e.title : "دریافت نشد"}</b>
            </h3>
            <p className="my-1"> {e ? e.description : "دریافت نشد"}</p>
          </div>
          <img
            src={`${config.docUrl}${e ? e.path : null}`}
            className="col-6"
            width="100%"
            height="100%"
          />
        </>
      );
    } else {
      return (
        <img
          src={`${config.docUrl}${e ? e.path : null}`}
          width="100%"
          height="100%"
        />
      );
    }
  };
  const style = {
    textAlign: "center",
    background: "teal",
    padding: "200px 0",
    fontSize: "30px",
  };

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [

    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
  };


  return (
    <>
      {state.banners && (
        <>

          <Slider
            {...settings}
            style={{ height: "100%", width: "100%" }}
            className="mx-auto"
          >
            {/* <div className="d-flex align-items-center"> */}
         
              <a className="p-1" href={state?.banners[0]?.link}>
                <img
                  src={`https://ebus.ir/service${state?.banners[0]?.path}`}
                  width="100%"
                  height="100%"
                  alt="banner"
                />
              </a> 
             <a className="p-1" href={state?.banners[1]?.link}>
                <img
                  src={`https://ebus.ir/service${state?.banners[1]?.path}`}
                  width="100%"
                  height="100%"
                  alt="banner"
                />
              </a>
            {/* </div> */}
            {/* <div className="d-flex align-items-center"> */}
              <a className="p-1" href={state?.banners[2]?.link}>
                <img
                  src={`https://ebus.ir/service${state?.banners[2]?.path}`}
                  width="100%"
                  height="100%"
                  alt="banner"
                />
              </a>
              <a className="p-1" href={state?.banners[3]?.link}>
                <img
                  src={`https://ebus.ir/service${state?.banners[3]?.path}`}
                  width="100%"
                  height="100%"
                  alt="banner"
                />
              </a> 
            {/* </div> */}
          </Slider>
        </>
      )}
    </>
  );
};

export default MaskAndDiscount;
